"use client"

const Footer = () =>{


    return(
        <div className="w-screen absolute h-[20vh] flex flex-col justify-center items-center bg-opacity-10 bg-blur-md bg-gray-200 backdrop-filter backdrop-blur-md ">
            <div className="flex justify-center items-center">
                <div className="flex w-[70vw] md:w-[25vw] mt-[15px] h-[25px] md:h-[40px] justify-between">
                    <img src="./assets/gmail.png" onClick={()=>{window.open('mailto:' + 'bprajeeth285@gmail.com', "_blank")}} className="object-contain my-[1px] hover:scale-125 hover:cursor-pointer"></img>
                    <img  src="./assets/linkedin.png" onClick={()=>{window.open("https://www.linkedin.com/in/bprajeeth/", "_blank")}} className="object-contain hover:scale-125 hover:cursor-pointer"></img>
                    <img src="./assets/github.png" onClick={()=>{window.open("https://github.com/bprajeeth", "_blank")}} className="object-contain hover:scale-125 hover:cursor-pointer"></img>
                    <img src="./assets/medium.png" onClick={()=>{window.open("https://medium.com/@bprajeeth03", "_blank")}} className="object-contain hover:scale-125 hover:cursor-pointer"></img>
                    <img src="./assets/twitter.png" onClick={()=>{window.open("https://twitter.com/bprajeeth", "_blank")}} className="object-contain hover:scale-125 hover:cursor-pointer"></img>
                </div> 
            </div>
            <p className="text-lg font-semibold font-poppins mt-4 text-gray-400">Created with ❤️ by <a className="text-cyan-400" href="https://www.linkedin.com/in/bprajeeth/" target="_blank">Prajeeth</a></p>
            
        </div>
    );
}

export default Footer;